import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase/client';
import { SignupForm } from '../../components/auth/SignupForm';
import AuthLayout from '../../components/auth/AuthLayout';

export default function SignupPage() {
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleSignup = async (email: string, password: string, name: string) => {
    try {
      setError(null);
      
      // Basic validation
      if (!email || !password || !name) {
        throw new Error('All fields are required');
      }

      if (password.length < 6) {
        throw new Error('Password must be at least 6 characters long');
      }

      // Sign up with Supabase
      const { data, error: signUpError } = await supabase.auth.signUp({
        email,
        password,
        options: {
          data: {
            full_name: name
          }
        }
      });

      if (signUpError) throw signUpError;
      if (!data?.user) throw new Error('Signup failed - please try again');

      // Navigate to onboarding
      navigate('/dashboard', { replace: true });
      
    } catch (err) {
      console.error('Signup error:', err);
      setError(err instanceof Error ? err.message : 'An error occurred during signup');
      throw err;
    }
  };

  return (
    <AuthLayout 
      title="Create your account" 
      subtitle="Start your journey with Gekko"
    >
      <SignupForm onSubmit={handleSignup} error={error} />
    </AuthLayout>
  );
}